// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    color: "#000000" /* Store Custom Code */,
};

export default focus;
